Controller.$inject = [];

function Controller() {
}

export function HuiSelectedItem() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: () => {
            return `<div class="hui-input-selected-item" ng-transclude></div>`;
        }
    };
}